import { transformKeys, defaultCanvasContext } from '../shapes/Element';
import * as mat3 from '../../js/mat3';
import { SVG_NAMESPACE, XLINK_NAMESPACE, IDENTRY_MATRIX } from '../constant';
import { getSVGColor, isGradient, isPattern, } from '../color';
function getSvgMatrix(matrix) {
    var transform = [matrix[0], matrix[1], matrix[3], matrix[4], matrix[6], matrix[7]];
    return "matrix(" + transform.join(' ') + ")";
}
export var SVGAttributeMap = {
    'clip-path': 'clip',
    fill: 'fill',
    stroke: 'stroke',
    'stroke-width': 'lineWidth',
    'stroke-linecap': 'lineCap',
    'stroke-linjoin': 'lineJoin',
    'stroke-miterlimit': 'miterLimit',
    'stroke-dasharray': 'lineDash',
    'stroke-dashoffset': 'lineDashOffset',
    'font-size': 'fontSize',
    'font-weight': 'fontWeight',
    'font-family': 'fontFamily',
    'font-style': 'fontStyle',
    display: 'display',
    // anchor: string;
    // transform: string;
    opacity: 'opacity',
    'fill-opacity': 'fillOpacity',
    'stroke-opacity': 'strokeOpacity',
    // filter: 'filter',
    cursor: 'cursor',
};
export function getSVGRootAttributes(width, height) {
    return {
        width: width,
        height: height,
        fill: 'none',
        xmlns: SVG_NAMESPACE,
        'xmlns:xlink': XLINK_NAMESPACE,
        style: "user-select: none;cursor: default;font-size:" + (defaultCanvasContext.fontSize + 'px') + "; font-family: " + defaultCanvasContext.fontFamily,
    };
}
export function getSVGStyleAttributes(node) {
    var _a = node.attr, fill = _a.fill, stroke = _a.stroke, color = _a.color, lineWidth = _a.lineWidth, lineDash = _a.lineDash, lineDashOffset = _a.lineDashOffset, lineCap = _a.lineCap, miterLimit = _a.miterLimit, lineJoin = _a.lineJoin, opacity = _a.opacity, fillOpacity = _a.fillOpacity, strokeOpacity = _a.strokeOpacity, cursor = _a.cursor, display = _a.display, fontSize = _a.fontSize, fontFamily = _a.fontFamily, fontWeight = _a.fontWeight, fontStyle = _a.fontStyle, shadowColor = _a.shadowColor, shadowBlur = _a.shadowBlur, markerStart = _a.markerStart, markerEnd = _a.markerEnd;
    var ret = {};
    var clip = node.getClipElement();
    var selfMatrix = node.getTransform();
    var dragOffset = node.getDragOffset();
    var hasDrag = dragOffset[0] !== 0 || dragOffset[1] !== 0;
    if (clip) {
        ret['clip-path'] = "url(#" + getClipId(clip) + ")";
    }
    if (hasDrag || selfMatrix !== IDENTRY_MATRIX || transformKeys.some(function (key) { return key in node.attr; })) {
        if (!hasDrag) {
            ret.transform = getSvgMatrix(selfMatrix);
        }
        else {
            var globalTransform = node.getGlobalTransform();
            var parentTransform = node.parentNode.getGlobalTransform();
            var out = mat3.createVec3();
            mat3.multiply(out, mat3.invert(out, parentTransform), globalTransform);
            ret.transform = getSvgMatrix(out);
        }
    }
    if (fill) {
        ret.fill = getSVGColor(fill);
    }
    if (stroke) {
        ret.stroke = getSVGColor(stroke);
    }
    if (color) {
        ret.color = getSVGColor(color);
    }
    if (lineWidth !== undefined && lineWidth >= 0) {
        ret['stroke-width'] =
            (node.attr.strokeNoScale ? node.getExtendAttr('lineWidth') : lineWidth) + '';
    }
    if (opacity !== undefined) {
        ret.opacity = opacity + '';
    }
    if (fillOpacity !== undefined) {
        ret['fill-opacity'] = fillOpacity + '';
    }
    if (strokeOpacity !== undefined) {
        ret['stroke-opacity'] = strokeOpacity + '';
    }
    if (!display) {
        ret.display = 'none';
    }
    if (cursor) {
        ret.cursor = cursor;
    }
    if (fontSize !== undefined) {
        ret['font-size'] = fontSize + '';
    }
    if (fontWeight !== undefined) {
        ret['font-weight'] = fontWeight + '';
    }
    if (fontFamily !== undefined) {
        ret['font-family'] = fontFamily;
    }
    if (fontStyle !== undefined) {
        ret['font-style'] = fontStyle;
    }
    if (lineDash) {
        ret['stroke-dasharray'] = lineDash.join(' ');
    }
    if (lineDashOffset !== undefined) {
        ret['stroke-dashoffset'] = lineDashOffset + '';
    }
    if (lineCap) {
        ret['stroke-linecap'] = lineCap;
    }
    if (lineJoin) {
        ret['stroke-linejoin'] = lineJoin;
    }
    if (miterLimit) {
        ret['stroke-miterlimit'] = miterLimit + '';
    }
    if (shadowColor && shadowBlur >= 0) {
        ret.filter = "url(#" + node.getShadowObj().id + ")";
    }
    if (markerStart) {
        ret['marker-start'] = "url(#" + markerStart.getMarkerId() + ")";
    }
    if (markerEnd) {
        ret['marker-end'] = "url(#" + markerEnd.getMarkerId() + ")";
    }
    return ret;
}
export function getAllDefsClips(group, out) {
    if (out === void 0) { out = []; }
    group.eachChild(function (child) {
        var clip = child.getClipElement();
        if (clip && !clip.parentNode && out.indexOf(clip) === -1) {
            out.push(clip);
        }
        if (child.isGroup) {
            getAllDefsClips(child, out);
        }
    });
    return out;
}
export function getAllDefsGradientAndPattern(group, out) {
    if (out === void 0) { out = []; }
    group.eachChild(function (child) {
        var _a = child.attr, fill = _a.fill, stroke = _a.stroke;
        if (isGradient(fill) || isPattern(fill)) {
            out.indexOf(fill) === -1 && out.push(fill);
        }
        if (isGradient(stroke) || isPattern(stroke)) {
            out.indexOf(stroke) === -1 && out.push(stroke);
        }
        if (child.isGroup) {
            getAllDefsGradientAndPattern(child, out);
        }
    });
    return out;
}
export function getAllMarkers(group, out) {
    if (out === void 0) { out = []; }
    group.eachChild(function (child) {
        var _a = child.attr, markerStart = _a.markerStart, markerEnd = _a.markerEnd;
        if (markerStart) {
            out.indexOf(markerStart) === -1 && out.push(markerStart);
        }
        if (markerEnd) {
            out.indexOf(markerEnd) === -1 && out.push(markerEnd);
        }
        if (child.isGroup) {
            getAllMarkers(child, out);
        }
    });
    return out;
}
export function getAllShadows(group, out) {
    if (out === void 0) { out = []; }
    group.eachChild(function (child) {
        var _a = child.attr, shadowColor = _a.shadowColor, shadowBlur = _a.shadowBlur;
        if (shadowColor && shadowBlur >= 0) {
            var shadow = child.getShadowObj();
            out.indexOf(shadow) === -1 && out.push(shadow);
        }
        if (child.isGroup) {
            getAllShadows(child, out);
        }
    });
    return out;
}
export function getClipId(node) {
    return "okee-render-clip-" + node.id;
}
